


























import { Component, Prop, Vue } from 'vue-property-decorator';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
@Component({
  components: {
    StandardCard,
    PrimaryButton,
  },
})
export default class Modal extends Vue {
  @Prop()
  public msg!: string;

  @Prop() public onClick!: () => void;

  private dialog: boolean = false;
}
